import React, {useEffect, useMemo, useState} from 'react';
import {Nav, Navbar, NavDropdown} from 'react-bootstrap';
import languageIcon from '../../../assets/images/icon_language_black.svg';
import menuToggle from '../../../assets/images/icons/i-menu-toggle.svg';
import {Trans, useTranslation} from 'react-i18next';
import languages from '../../../configs/languages';
import './index.css';
import PinkButton from '../../button/pinkbutton';
import pathUtils from '../../../utils/pathUtils';
import webUtils from '../../../utils/webUtils';
import {XLg} from 'react-bootstrap-icons';
import usePFSiteLinks from '../../../hooks/usePFSiteLinks';
import _get from 'lodash/get';

export default function Menu() {
  const {i18n} = useTranslation();
  let langs = languages.default;
  const isMobile = webUtils.isMobile();
  const curLang = useMemo(() => langs.find((l) => l.code === i18n.language), [i18n.language]);
  const [expand, setExpand] = useState(false);
  const {getAboutLink, getPlanLink, getTrialButtonContent} = usePFSiteLinks();
  const trialButtonContent = getTrialButtonContent();

  const getTitle = () => {
    return (
      <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
        <img alt="" src={languageIcon} width="22" height="22" style={{marginRight: '4px'}} /> {curLang.text}
      </div>
    );
  };

  return (
    <div className="menu-right">
      {isMobile && (
        <PinkButton
          className="menu__start-trial-btn"
          bgColor="linear"
          link={_get(trialButtonContent, 'url')}
          text={_get(trialButtonContent, 'text')}
          isNewTab={true}
          id="startFreeTrialBtn"
          square={true}
        />
      )}
      <Navbar className="menu-nav" expand="md" style={{height: 60}}>
        <Navbar.Toggle
          onClick={() => {
            setExpand(!expand);
          }}
        >
          {expand ? <XLg size={26} color="#000" /> : <img src={menuToggle} width={26} />}
        </Navbar.Toggle>

        <Navbar.Collapse className={isMobile ? 'menu-nav-expand' : ''} id="basic-navbar-nav" style={{textAlign: isMobile ? '' : 'right'}}>
          <Nav className="menu-nav-container">
            <Nav.Link className="menu-nav-link nav-link" target="_blank" href={getAboutLink()}>
              <Trans i18nKey="menu.about.online.service">About Online Service</Trans>
            </Nav.Link>
            <Nav.Link className="menu-nav-link" target="_blank" href={getPlanLink()}>
              <Trans i18nKey="menu.plan.pricing">Plan & Pricing</Trans>
            </Nav.Link>
            <Nav.Link className="menu-nav-link" target="_blank" href={pathUtils.getConsoleURL()}>
              <Trans i18nKey="menu.sign.in">Sign In</Trans>
            </Nav.Link>
            <NavDropdown title={getTitle()} id="basic-nav-dropdown">
              {langs.map((lang, i) => (
                <NavDropdown.Item
                  eventKey={lang.code}
                  onClick={(eventKey, event) => {
                    window.location.href = pathUtils.replaceUrlLang(lang.code, window.location.pathname, window.location.search);
                  }}
                  key={i}
                >
                  {lang.text}
                </NavDropdown.Item>
              ))}
            </NavDropdown>
            {isMobile && (
              <Nav.Link style={{backgroundColor: '#f2f2f2'}}>
                <span>{curLang.text}</span>
              </Nav.Link>
            )}
          </Nav>
        </Navbar.Collapse>
      </Navbar>
      {!isMobile && (
        <PinkButton
          className="menu__start-trial-btn"
          bgColor="linear"
          link={_get(trialButtonContent, 'url')}
          text={_get(trialButtonContent, 'text')}
          isNewTab={true}
          id="startFreeTrialBtn"
          square={true}
        />
      )}
      {expand ? <div className="menu-container" /> : ''}
    </div>
  );
}
